import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import * as setupReducer from "containers/Setup/reducer";
import * as createWizardReducer from "containers/CreateWizard/reducer";
import * as transformReducer from "containers/Dataset/reducer";

import DatasetViewContainer from "containers/View/Dataset";
import AcademicReviewDataset from "components/CreateWizard/Academic/AcademicReviewDataset";

const bId = "academicReviewDataset";

class AcademicReviewDatasetContainer extends React.PureComponent {
  handleUpdateSelection(selection) {
    const { updateSelection, generateNameAndUpdate, blueprintId, id } = this.props;

    return updateSelection(selection).then(() => {
      if (id === "new" && (blueprintId === "template" || blueprintId === "academic"))
        return generateNameAndUpdate(selection.value, blueprintId === "academic" ? undefined : "Optimized");
    });
  }

  getIsCategorical(blueprint) {
    return (
      blueprint &&
      blueprint.wizard &&
      blueprint.wizard.dataset &&
      blueprint.wizard.dataset.outcome &&
      blueprint.wizard.dataset.fields &&
      blueprint.wizard.dataset.fields[blueprint.wizard.dataset.outcome] &&
      blueprint.wizard.dataset.fields[blueprint.wizard.dataset.outcome].type === "categorical"
    );
  }

  getIsNumerical(blueprint) {
    return (
      blueprint &&
      blueprint.wizard &&
      blueprint.wizard.dataset &&
      blueprint.wizard.dataset.outcome &&
      blueprint.wizard.dataset.fields &&
      blueprint.wizard.dataset.fields[blueprint.wizard.dataset.outcome] &&
      blueprint.wizard.dataset.fields[blueprint.wizard.dataset.outcome].type === "number"
    );
  }

  render() {
    const { blueprintId, id, index, blueprint, transformed } = this.props;

    return (
      <AcademicReviewDataset
        {...this.props}
        datasetView={
          <DatasetViewContainer
            blueprintId={blueprintId}
            isCategorical={this.getIsCategorical(blueprint)}
            isNumerical={this.getIsNumerical(blueprint)}
            onClick={(s) => this.handleUpdateSelection({ value: s })}
          />
        }
        updateSelection={(selection) => this.handleUpdateSelection({ value: selection })}
      />
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateSelection: (selection) =>
    dispatch(
      setupReducer.updateDatasetId(ownProps.id, selection.value, true, ownProps.index, ownProps.blueprintId, true)
    ),
  generateNameAndUpdate: (datasetId, message) =>
    dispatch(setupReducer.generateNameAndUpdate(ownProps.id, datasetId, message)),
  updateSuccess: (success) => {
    dispatch(setupReducer.updateSuccess(ownProps.runId, success));
    dispatch(setupReducer.checkCounts(ownProps.runId));
  },
  updateSplitColumn: (column) => dispatch(setupReducer.updateSplitColumn(ownProps.id, column)),
  updateStep: (step) => dispatch(createWizardReducer.updateStep(step)),
  updateIgnored: (column, isIgnored) => dispatch(setupReducer.updateIgnored(ownProps.id, column, isIgnored)),
  setCustomMapping: (customFieldId, datasetColumn) =>
    dispatch(setupReducer.setCustomMapping(ownProps.id, ownProps.blueprintId, customFieldId, datasetColumn))
});

const mapStateToProps = (state, ownProps) => {
  const selectedDataset = ownProps.selectedDataset
    ? ownProps.selectedDataset
    : setupReducer.getDatasetFromSetup(state, ownProps.id);
  const outcomeType = selectedDataset ? setupReducer.getOutcomeType(state, ownProps.id) : null;
  const aiReadyMetrics = setupReducer.getAiReadyMetrics(state, ownProps.id) || {};
  const correlations = setupReducer.getCorrelationMetricsFromDataset(state, ownProps.id) || {};

  return {
    selectedDataset: selectedDataset,
    outcomeType: outcomeType,

    selectedSuccess: setupReducer.getSuccess(state, ownProps.id),
    successOptions: setupReducer.getSuccessOptions(state, ownProps.id),
    successOptionsWarning: setupReducer.getSuccessOptionsWarning(state, ownProps.id),
    blueprint: setupReducer.getBlueprintFromSetup(state, ownProps.id),

    splitOptions: setupReducer.getSplitOptions(state, ownProps.id),
    splitColumn: setupReducer.getSplitColumn(state, ownProps.id),

    step: createWizardReducer.getStep(state),
    ignored: setupReducer.getIgnored(state, ownProps.id),

    problematicPredictors: correlations.problematicPredictors,
    predictors: correlations.predictors,

    transformed: transformReducer.getTransformArr(state, ownProps.id),
    aiReadyFields: aiReadyMetrics.aiReady,
    notAiReadyFields: aiReadyMetrics.notAiReady,
    isAiReady: aiReadyMetrics.isAiReady,
    aiReadyWarning: aiReadyMetrics.warning,
    isMultiCategoryOutcome: aiReadyMetrics.isMultiCategoryOutcome,

    customMappings: setupReducer.getCustomMappingsArr(state, ownProps.id),
    customMappingOptions: setupReducer.getCustomMappingOptions(state, ownProps.id),
    validCustomMappings: setupReducer.getIsValidCustomMappings(state, ownProps.id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(AcademicReviewDatasetContainer);
